import { Component } from "react"
import DataTable from "react-data-table-component"
import ContentContainer from "../../../containers/UI/ContentContainer/ContentContainer"
import axios from "../../../axios"
import classes from "./deals.css"
import Modal from "./DealModal/DealModal"



class PartsCatalog extends Component {

  columns = [
    { name: "Customer", selector: "customer", sortable: true, left: true, style: { fontSize: "15px" }, maxWidth: "350px", format: (row) => this.state.customerNames[row.customer] ?? ""},
    { name: "Description", selector: "description", sortable: true, left: true, style: { fontSize: "15px" }, maxWidth: "350px"},
    { name: "Progress", selector: "gatewayAmount", sortable: true, left: true, style: { fontSize: "15px" }, maxWidth: "300px", format: (row) => row.usedAmount + " / " + row.gatewayAmount + " gateway" + (row.usedAmount !== 1 ? "s" : "")},
    { name: "Start date", selector: "startDate", sortable: true, left: true, style: { fontSize: "15px" }},
    { name: "End date", selector: "endDate", sortable: true, left: true, style: { fontSize: "15px" }},
  ]

  state = {
    deals: [],
    selectedItem: null,
    showModal: false,

    customerOptions: [],
    customerNames: {}
  }


  componentDidMount() {

    // Fetch customer options
    axios.get("/customers/allReduced").then(response => {
      if (response.data) {

        let customerOptions = []
        let customerNames = {}
        response.data.forEach((el) => {
          // Map into Select component
          customerOptions.push({ label: el.name, value: el._id })
          // Create lookup ID -> name
          customerNames[el._id] = el.name
        })

        this.setState({ customerOptions, customerNames })

        // Load deals after customer options
        this.loadDeals()
      }
    })
  }

  loadDeals = () => {

    // Fetch deals
    axios.get("/deals/all").then(response => {
      if (response.data) {

        // Format start / end date as string
        let deals = response.data.map(deal => {
          deal.startDate = formatDate(deal.startDate)
          deal.endDate = formatDate(deal.endDate)
          return deal
        })

        // Update state
        this.setState({ deals })
      }
    })
  }

  closeModal = () => {

    // Close the modal in state
    this.setState({ showModal: false, selectedDeal: undefined })

    // Refresh the list
    setTimeout(() => {
      this.loadDeals()
    }, 500)
  }

  render() {
    return (
      <ContentContainer title="Deals">
        <button onClick={() => this.setState({ showModal: true, selectedDeal: undefined })} className={classes.addButton}>Add deal</button>

        <DataTable
          striped
          noHeader
          pagination
          highlightOnHover
          columns={this.columns}
          data={this.state.deals}
          defaultSortField={"name"}
          defaultSortAsc={false}
          customStyles={{ headCells: { style: { fontWeight: "bold", fontSize: "15px" }}}}
          onRowClicked={(deal) => this.setState({ showModal: true, selectedDeal: deal })}
        />

        {this.state.showModal && <>
          <Modal
            shouldShow={this.state.showModal}
            selectedDeal={this.state.selectedDeal}
            customerOptions={this.state.customerOptions}
            closeModal={() => this.closeModal()}/>
          </>
        }

      </ContentContainer>
    );
  }
}

function formatDate(epoch) {
  
  if (epoch) {
    if (!isNaN(epoch)) {
      // Create date
      let date = new Date(0)
      date.setUTCSeconds(epoch)
      // Format properly
      return date.toLocaleDateString("en-GB", { year: "numeric", month: "numeric", day: "numeric"})
    }
  }
  return ""
}

export default PartsCatalog;
